import type React from 'react';

import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useEmailDecisionMakerModalBody } from './hooks/useEmailDecisionMakerModalBody';

export const EmailDecisionMakerModalBody: React.FC = () => {
	const {
		data: { decisionMakers },
		actions: { handleEmailClick },
	} = useEmailDecisionMakerModalBody();

	return (
		<ul>
			{decisionMakers.map((dm, index) => (
				<li key={dm.id}>
					<Flex>
						<Avatar
							variant="subtle"
							data-testid="dm-image"
							src={dm.photo?.userMedium.url}
							mr={10}
							size={50}
							alt=""
							loading="lazy"
						/>
						<Box>
							<Text size="large" fontWeight="semibold" ellipsis>
								{dm.displayName}
							</Text>

							{dm.title && (
								<Text size="small" ellipsis>
									{dm.title}
								</Text>
							)}
						</Box>

						<Box ml="auto">
							<Link
								to={dm.emailHref || ''}
								target="_blank"
								variant="primary"
								sx={{ fontSize: '12px' }}
								onClick={handleEmailClick}
							>
								Send them an email
							</Link>
						</Box>
					</Flex>
					{index !== decisionMakers.length - 1 && (
						<Separator role="presentation" my={20} sx={{ color: 'neutral-grey100' }} />
					)}
				</li>
			))}
		</ul>
	);
};
